import { useTheme } from "@mui/material/styles";
import { TextField } from "@mui/material";
import React from "react";

const CustomInput = ({
  name,
  min,
  id,
  required,
  readOnly,
  minRows,
  multiline,
  endAdornment,
  label,
  value,
  type,
  placeholder,
  onChange,
  onBlur,
  error,
  disabled,
  helperText,
  InputProps,
}) => {
  const theme = useTheme(); // Access the current theme
  
  return (
    <TextField
      name={name}
      fullWidth
      sx={{
        "& input": {
          color: theme.palette.text.primary,
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
          padding: "10px",
          backgroundColor:
            theme.palette.mode === "dark"
              ? "transparent"
              : theme.palette.secondary.light,
          borderRadius: "4px",
          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            marginBottom: 1,
          },
          "&[type=number]": {
            "-moz-appearance": "textfield",
          },
        },
        "& .Mui-disabled": {
          WebkitTextFillColor: theme.palette.text.disabled,
          "& fieldset": {
            borderColor: theme.palette.border.primary,
          },
        },
        // Default border color (transparent when not focused)
        "& fieldset": {
          borderColor: theme.palette.border.primary,
        },        
        // Hover border color
        "& fieldset:hover": {
          borderColor: theme.palette.border.primary,
        },
        // Focused state (show border color when focused or touched)
        "& .MuiOutlinedInput-root": {
          borderRadius: "4px",
          "&:hover": {
            "& fieldset": {
              borderColor: theme.palette.border.main,
            },
          },
          "&.Mui-focused": {
            "& fieldset": {
              borderColor: theme.palette.border.main,
            },
          },
        },
        "& .MuiFormLabel-root": {
          color: "theme.palette.primary.main",
          fontSize: "16px",
          lineHeight: "20px",
          transform: "translate(14px, 10px) scale(1)",

          "&.Mui-focused": {
            color: "theme.palette.primary.main",
            fontSize: "16px",
            lineHeight: "20px",
          },
        },
        // Label color
        ".MuiInputLabel-shrink": {
          color: "theme.palette.primary.main",
          transform: "translate(14px, -9px) scale(0.75)",
        },
        // Icon color (for any adornments/icons)
        "& svg": {
          fill: theme.palette.text.secondary,
        },
        "& .MuiMenu-list": {
          backgroundColor: theme.palette.background.paper,
        },
      }}
      id={id}
      min={min}
      readOnly={readOnly}
      multiline={multiline}
      minRows={minRows}
      type={type}
      required={required}
      endAdornment={endAdornment}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      value={value}
      label={label}
      helperText={helperText}
      onChange={onChange}
      InputProps={InputProps}
      inputProps={{
        min,
      }}
    />
  );
};

export default CustomInput;
